import React, { useEffect, useState } from 'react';
import '../../css/cards/Master.css';

import { IoCaretForwardOutline } from 'react-icons/io5';
import { useDispatch } from 'react-redux';

import { openVideo } from '../../features/video';

import { getRemainingTimeUntilMsTimestamp } from '../../utils/countdown';
import { isWebpSupported } from 'react-image-webp/dist/utils';

import dayjs from 'dayjs';

const days = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
const months = [
	'Enero',
	'Febrero',
	'Marzo',
	'Abril',
	'Mayo',
	'Junio',
	'Julio',
	'Agosto',
	'Septiembre',
	'Octubre',
	'Noviembre',
	'Diciembre',
];

const defaultRemainingTime = {
	seconds: '00',
	minutes: '00',
	hours: '00',
	days: '00',
};

const Master = ({ image, imageWebp, title, info, countdownTimestampMs, url, video }) => {
	const dispatch = useDispatch();
	const timestampDayjs = dayjs(countdownTimestampMs);
	const nowDayjs = dayjs();
	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	const descriptionArray = Array.isArray(info) ? (
		<ul className='master-information-text-list'>
			{info?.map((description, i) => (
				<li>{description}</li>
			))}
		</ul>
	) : (
		<div className='master-information-text'>
			<p>{info}</p>
		</div>
	);

	return (
		<div className='Master'>
			<div
				className='master-banner'
				style={{
					backgroundImage: `url(${image})`,
				}}
			>
				<button
					className='master-play'
					onClick={() => {
						dispatch(
							openVideo({
								modal: true,
								url: video,
								type: 'common',
							})
						);
					}}
				>
					<IoCaretForwardOutline style={{ marginLeft: 2 }} />
				</button>
				<a
					href={url}
					//  target='_blank'
					rel='noreferrer'
					className='master-start-now'
				>
					Más Información
				</a>
			</div>
			<div className='master-information'>
				<div className='master-information-title'>
					<a
						href={url}
						// target='_blank'
						rel='noreferrer'
					>
						{title}
					</a>
				</div>
				<div className='master-information-price'>
					<div className='line'></div>
				</div>

				{descriptionArray}

				<div className='master-information-start'>
					{countdownTimestampMs ? (
						nowDayjs.isAfter(timestampDayjs) ? (
							<>
								<h1 style={{ fontSize: 21, color: '#6000de' }}>
									Empieza en el momento que desees.
								</h1>
							</>
						) : (
							<>
								<h4
									style={{
										width: '100%',
										display: 'flex',
										justifyContent: 'space-evenly',
										fontSize: 16,
										fontWeight: 400,
										borderBottom: '1px solid var(--line)',
										marginBottom: 10,
										paddingBottom: 10,
									}}
								>
									<span style={{ fontWeight: 600 }}>Comienza: </span>
									{days[timestampDayjs.day() - 1]
										? days[timestampDayjs.day() - 1]
										: 'Domingo'}, {timestampDayjs.date()} de {months[timestampDayjs.month()]}
								</h4>
								<h5>FALTAN</h5>
								<div className='master-date'>
									<div className='segment'>
										<div className='numbers'>{remainingTime.days}</div>
										<div className='letters'>DÍAS</div>
									</div>
									<div className='segment'>
										<div className='numbers'>{remainingTime.hours}</div>
										<div className='letters'>HOR</div>
									</div>
									<div className='segment'>
										<div className='numbers'>{remainingTime.minutes}</div>
										<div className='letters'>MIN</div>
									</div>
									<div className='segment'>
										<div className='numbers'>{remainingTime.seconds}</div>
										<div className='letters'>SEG</div>
									</div>
								</div>
							</>
						)
					) : (
						<>
							<h2 style={{ color: '#6000de' }}>Empieza en el momento que desees.</h2>
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default Master;
